// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import API_URL from "../../src/Config";
// import axios from "axios";
// import "./Login.css";
// import loginVideo from "./login-page-video.mp4";

// const Login = ({ onLogin }) => {
//   const navigate = useNavigate();
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [alertMessage, setAlertMessage] = useState("");
//   const [usernameError, setUsernameError] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleSignIn = async () => {
//     setUsernameError("");
//     setPasswordError("");

//     if (!username.trim()) {
//       setUsernameError("Enter Your Username.");
//       return;
//     }

//     if (!password.trim()) {
//       setPasswordError("Enter Your Password.");
//       return;
//     }

//     try {
//       setLoading(true);

//       const response = await axios.post(`${API_URL}/api/login`, {
//         username,
//         password,
//       });

//       const {
//         message,
//         auth_key,
//         name,
//         email,
//         company_id,
//         user_role,
//         project_type,
//       } = response.data;

//       setAlertMessage(message);

//       // Call onLogin with all required fields
//       onLogin(auth_key, name, email, company_id, user_role, project_type);

//       // if (project_type === 'Maintainence') {
//       //   navigate('/dashboard');
//       // } else if (project_type === 'BOQ') {
//       //   navigate('/gas-detectors');
//       // } else {
//       //   navigate('/dashboard');
//       // }

//       if (project_type === "BOQ") {
//         navigate("/gas-detectors");
//       } else {
//         navigate("/dashboard");
//       }
//     } catch (error) {
//       console.error("Full error:", error);
//       if (error.response && error.response.status === 401) {
//         const message = error.response.data.message;
//         console.error("Sign in failed:", message);
//         setAlertMessage(message);
//       } else {
//         console.error("An error occurred during sign in:", error.message);
//         setAlertMessage("An error occurred during sign in");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     handleSignIn();
//   };

//   return (
//     <div className="login-container">
//       <div className="login-content">
//         <div className="login-content-left">
//           <div className="login-content-left-content">
//             <video autoPlay muted loop playsInline className="background-video">
//               <source src={loginVideo} type="video/mp4" />
//             </video>
//           </div>
//         </div>
//         <div className="login-content-right">
//           <div className="login-content-right-content">
//             <div className="login-heading">
//               <img src="/logo.png" alt="Logo" className="login-logo" />
//             </div>
//             <div className="login-body">
//               <div className="welcome">Welcome back !</div>
//               <p>Hey, Enter your details to get log in to your account.</p>
//               <div className="login-alert">
//                 {alertMessage && (
//                   <div
//                     className={`alert ${
//                       alertMessage.includes("Invalid")
//                         ? "alert-danger"
//                         : "alert-success"
//                     }`}
//                   >
//                     {alertMessage}
//                   </div>
//                 )}
//               </div>
//               <div className="login-form">
//                 <form className="form" onSubmit={handleSubmit}>
//                   <div className="login-form-table">
//                     <label htmlFor="email">Email address:</label> <br />
//                     <input
//                       type="text"
//                       className={`form-controls ${
//                         usernameError ? "is-invalid" : ""
//                       }`}
//                       placeholder="Enter username or email"
//                       value={username}
//                       onChange={(e) => {
//                         setUsername(e.target.value);
//                         setUsernameError("");
//                       }}
//                     />
//                     {usernameError && (
//                       <div className="invalid-feedbacks">{usernameError}</div>
//                     )}
//                   </div>
//                   <div className="login-form-table">
//                     <label htmlFor="password">Password:</label> <br />
//                     <input
//                       type="password"
//                       className={`form-controls ${
//                         passwordError ? "is-invalid" : ""
//                       }`}
//                       placeholder="Enter password"
//                       value={password}
//                       onChange={(e) => {
//                         setPassword(e.target.value);
//                         setPasswordError("");
//                       }}
//                     />
//                     {passwordError && (
//                       <div className="invalid-feedbacks">{passwordError}</div>
//                     )}
//                   </div>
//                   <div className="login-button">
//                     <button
//                       type="submit"
//                       disabled={loading}
//                       className="login-btn"
//                     >
//                       {loading ? <div className="loads" /> : "LOG IN"}
//                     </button>
//                   </div>
//                   <div className="login-end"></div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import API_URL from "../../src/Config";
// import axios from "axios";
// import "./NewLogin.css";

// const NewLogin = ({ onLogin }) => {
//   const navigate = useNavigate();
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [showPassword, setShowPassword] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [usernameError, setUsernameError] = useState("");
//   const [passwordError, setPasswordError] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handleSignIn = async () => {
//     setUsernameError("");
//     setPasswordError("");

//     if (!username.trim()) {
//       setUsernameError("Enter Your Username.");
//       return;
//     }

//     if (!password.trim()) {
//       setPasswordError("Enter Your Password.");
//       return;
//     }

//     try {
//       setLoading(true);

//       const response = await axios.post(`${API_URL}/api/login`, {
//         username,
//         password,
//       });

//       const {
//         message,
//         auth_key,
//         name,
//         email,
//         company_id,
//         user_role,
//         project_type,
//       } = response.data;

//       setAlertMessage(message);

//       onLogin(auth_key, name, email, company_id, user_role, project_type);

//       if (project_type === "BOQ") {
//         navigate("/gas-detectors");
//       } else {
//         navigate("/dashboard");
//       }
//     } catch (error) {
//       console.error("Full error:", error);
//       if (error.response && error.response.status === 401) {
//         const message = error.response.data.message;
//         console.error("Sign in failed:", message);
//         setAlertMessage(message);
//       } else {
//         console.error("An error occurred during sign in:", error.message);
//         setAlertMessage("An error occurred during sign in");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     handleSignIn();
//   };

//   return (
//     <div className="new_login_screen">
//       {/* Background Image */}
//       <div className="">
//         <div className="new_login_screen_background">
//           <img src="/new_img_1.png" alt="Industrial Background" />
//         </div>
//         <div className="new_login_screen_background">
//           <img src="/new_img_2.png" alt="Industrial Background" />
//         </div>
//         <div className="new_login_screen_background">
//           <img src="/new_img_3.png" alt="Industrial Background" />
//         </div>
//         <div className="new_login_screen_background">
//           <img src="/new_img_4.png" alt="Industrial Background" />
//         </div>
//       </div>

//       {/* Login Form */}
//       <div className="new_login_screen_form_container">
//         <div className="new_login_screen_logo">
//           <img src="/logo.png" alt="Keshav Encon" />
//           <div className="new_login_screen_logo_text">
//             <div className="new_login_screen_company_name">Keshav Encon</div>
//             <div className="new_login_screen_company_tagline">
//               ISO 9001 : 2008 Certify Company
//             </div>
//           </div>
//         </div>

//         <div className="new_login_screen_heading">
//           <h1>Welcome back !</h1>
//         </div>

//         <div className="new_login_screen_subheading">
//           <p>Hey, Enter your details to get log in to your account.</p>
//         </div>

//         {alertMessage && (
//           <div className="new_login_screen_alert">
//             <div
//               className={`alert ${
//                 alertMessage.includes("Invalid")
//                   ? "alert-danger"
//                   : "alert-success"
//               }`}
//             >
//               {alertMessage}
//             </div>
//           </div>
//         )}

//         <form className="new_login_screen_form" onSubmit={handleSubmit}>
//           <div className="new_login_screen_form_group">
//             <label htmlFor="email">Email address:</label>
//             <input
//               type="text"
//               id="email"
//               className={`form-controls ${usernameError ? "is-invalid" : ""}`}
//               placeholder="Enter username or email"
//               value={username}
//               onChange={(e) => {
//                 setUsername(e.target.value);
//                 setUsernameError("");
//               }}
//             />
//             {usernameError && (
//               <div className="invalid-feedbacks">{usernameError}</div>
//             )}
//           </div>

//           <div className="new_login_screen_form_group">
//             <label htmlFor="password">Password:</label>
//             <div className="new_login_screen_password_wrapper">
//               <input
//                 type={showPassword ? "text" : "password"}
//                 id="password"
//                 className={`form-controls ${passwordError ? "is-invalid" : ""}`}
//                 placeholder="Enter password"
//                 value={password}
//                 onChange={(e) => {
//                   setPassword(e.target.value);
//                   setPasswordError("");
//                 }}
//               />
//               <button
//                 type="button"
//                 className="new_login_screen_password_toggle"
//                 onClick={() => setShowPassword(!showPassword)}
//                 aria-label={showPassword ? "Hide password" : "Show password"}
//               >
//                 {showPassword ? (
//                   <svg
//                     width="20"
//                     height="20"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
//                     <line x1="1" y1="1" x2="23" y2="23" />
//                   </svg>
//                 ) : (
//                   <svg
//                     width="20"
//                     height="20"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                   >
//                     <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
//                     <circle cx="12" cy="12" r="3" />
//                   </svg>
//                 )}
//               </button>
//             </div>
//             {passwordError && (
//               <div className="invalid-feedbacks">{passwordError}</div>
//             )}
//           </div>

//           <div className="new_login_screen_button">
//             <button type="submit" disabled={loading} className="login-btn">
//               {loading ? <div className="loads" /> : "LOG IN"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default NewLogin;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_URL from "../../src/Config";
import "./NewLogin.css";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const NewLogin = ({ onLogin }) => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [emailError, setEmailError] = useState("");
const [passwordError, setPasswordError] = useState("");

  useEffect(() => {
    const authErrorMessage = sessionStorage.getItem("authErrorMessage");

    if (authErrorMessage) {
      setAlertMessage(authErrorMessage);
      sessionStorage.removeItem("authErrorMessage");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset errors
  setEmailError("");
  setPasswordError("");
  setAlertMessage("");

  let hasError = false;

  if (!username.trim()) {
    setEmailError("Email address is required");
    hasError = true;
  }

  if (!password.trim()) {
    setPasswordError("Password is required");
    hasError = true;
  }

  if (hasError) return;

    try {
      setLoading(true);

      const res = await axios.post(`${API_URL}/api/login`, {
        username,
        password,
      });

      const { auth_key, name, email, company_id, user_role, project_type } =
        res.data;

      onLogin(auth_key, name, email, company_id, user_role, project_type);

      navigate(project_type === "BOQ" ? "/gas-detectors" : "/dashboard");
    } catch (err) {
      setAlertMessage(
        err.response?.data?.message || "Invalid login credentials"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login_wrapper">
      {/* BACKGROUND GRID */}
      <div className="login_bg_grid">
        <img src="/new_img_1.png" alt="Crude Oil Storage" />
        <img src="/new_img_2.png" alt="POL Terminals" />
        <img src="/new_img_4.png" alt="Aircraft Refueling" />
        <img src="/new_img_3.png" alt="Petroleum Refinery" />
      </div>

      {/* DARK OVERLAY */}
      <div className="login_bg_overlay" />

      {/* LOGIN CARD */}
      <div
        className="login_card"
        style={{
          height: alertMessage || emailError || passwordError ? "557px" : "525px",
        }}
      >
        <div className="login_logo">
          <img src="/keshav_white_logo.png" alt="logo" className="login-logo" />
        </div>

        <div className="new_login_desc_div">
          <h3>
            <em>WELCOME BACK!</em>
          </h3>
          <span className="login_subtitle">
            Hey, Enter your details to get log in to your account
            {(emailError || passwordError || alertMessage) && (
    <div className="login_alert">
      {emailError && <div>{emailError}</div>}
      {passwordError && <div>{passwordError}</div>}
      {alertMessage && <div>{alertMessage}</div>}
    </div>
  )}
          </span>
        </div>

        <form onSubmit={handleSubmit}>
          <label htmlFor="email" className="new_login_form_label">
            Email address:
          </label>{" "}
          <br />
          <input
            type="text"
            placeholder="Email Address"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <div className="password_wrap">
            <label htmlFor="password" className="new_login_form_label">
              Password:
            </label>{" "}
            <br />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {/* <span onClick={() => setShowPassword(!showPassword)}>👁</span> */}
            <span
  className="password_toggle_icon"
  onClick={() => setShowPassword((prev) => !prev)}
>
  {showPassword ? (
    <AiOutlineEyeInvisible size={18} />
  ) : (
    <AiOutlineEye size={18} />
  )}
</span>

          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "LOGIN"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewLogin;
